



















































import { Vue, Component, Prop } from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class PaymentLogBody extends Vue {
  @Prop() readonly data!: any;

  @Prop() readonly paginationDetail!: object;

  @Prop() readonly sumFooter!: number;

  utilsInstance = utils;
}
